import React from 'react';
import AboutBelowContent from '../../Components/ExperienceBlocks/AboutBelowContent';

const Experience = () => {
    const headerData = {
        img: 'images/about/shadow_icon1.png',
        heading: 'Innovazione e Sostenibilità nella Costruzione',
        subheading: 'RB Costruzioni Srl',
    };

    const ExpericenData = [
        { id: '1', title: 'Esperienza', description: '17 anni nel settore.' },
        { id: '2', title: 'Affidabilità', description: 'Soluzioni economiche.' },
    ];

    return (
        <div className="experience section">
            <div className="container">
                <div className="row">
                <div class="col-lg-6">
                    <div className="group_image_holder type_1" style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                        <div class="expe_box">
                            <div class="expe_box_inner">
                                <h1>17</h1>
                                Anni di esperienza
                            </div>
                        </div>
                        <div class="image_object">
                            <img src="images/about/1.png" alt="esperienza" />
                            <div class="object"></div>
                        </div>
                    </div>
                </div>
                    <div className="col-lg-6 col-md-12">
                        <div className="experience_content">
                            <div className="section_header">
                                <h6 className="section_sub_title">{headerData.subheading}</h6>
                                    <h1 className="section_title">{headerData.heading}</h1>
                                    <p className="section_desc">
                                        <strong>RB COSTRUZIONI</strong> offre una gamma completa di servizi di <strong>COSTRUZIONE</strong> e <strong>RISTRUTTURAZIONE</strong> per soddisfare le esigenze di ogni cliente. Con oltre <strong>17 ANNI DI ESPERIENZA</strong>, siamo specializzati nella costruzione di edifici residenziali, fornendo soluzioni <strong>INNOVATIVE</strong> e di <strong>ALTA QUALITÀ</strong>.
                                        Ci occupiamo di ogni fase del processo di costruzione, dalla <strong>PROGETTAZIONE</strong> all'<strong>ESECUZIONE</strong>, garantendo risultati <strong>IMPECCABILI</strong> e <strong>DURATURI</strong>.
                                    </p>
                                <div className="about_below">
                                    {
                                        ExpericenData.map(data =>
                                            <AboutBelowContent
                                                key={data.id}
                                                data={data}
                                            />
                                        )
                                    }

                                </div>
                            </div>
                            {/* <a className="button" href="/chi-siamo">Scopri di più</a> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Experience;